import React from 'react'
import { useSignIn } from '@features/account/contexts/signin/_signIn'
import { SignInContext } from './_context'

export const SignInProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const {
    state,
    updateField,
    nextStep,
    previousStep,
    setCurrentStep,
    submit,
    canSubmit,
    canGoNext,
    canGoPrevious,
    isStepTouched,
    // Error handling
    setError,
    clearError,
    setValidationErrors,
    setFieldError,
    clearFieldErrors,
    resetContext,
    // recovery
    recoveryFormData,
    updateRecoveryField,
    handleRecoveryInputValueChange,
    recoveryCanSubmit,
    submitRecovery,
    recoveryLoading,
    recoveryError,
    // Enhanced recovery state
    recoveredUsername,
    passwordResetEmail,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    accountLockoutTime,
    resendEmailCooldown,
    // Enhanced recovery functions
    canResetPassword,
    isAccountLocked,
    canResendEmail,
    getRemainingLockoutTime,
    getRemainingResendTime,
    submitPasswordResetEmail,
    resendPasswordResetEmail,
    submitNewPassword,
    handleAccountLockout,
    copyUsernameToClipboard,
    goBackToSignInWithUsername,
    executeRecoveryApi,
  } = useSignIn()

  const value = React.useMemo(
    () => ({
      state,
      canGoNext: canGoNext(),
      canGoPrevious: canGoPrevious(),
      canSubmit: canSubmit(),
      isStepTouched: isStepTouched(),
      updateField,
      nextStep,
      previousStep,
      setCurrentStep,
      submit,
      // Error handling
      setError,
      clearError,
      setValidationErrors,
      setFieldError,
      clearFieldErrors,
      resetContext,
      // recovery
      recoveryFormData,
      updateRecoveryField,
      handleRecoveryInputValueChange,
      recoveryCanSubmit,
      submitRecovery,
      recoveryLoading,
      recoveryError,
      // Enhanced recovery state
      recoveredUsername,
      passwordResetEmail,
      newPassword,
      setNewPassword,
      confirmPassword,
      setConfirmPassword,
      accountLockoutTime,
      resendEmailCooldown,
      // Enhanced recovery functions
      canResetPassword,
      isAccountLocked,
      canResendEmail,
      getRemainingLockoutTime,
      getRemainingResendTime,
      submitPasswordResetEmail,
      resendPasswordResetEmail,
      submitNewPassword,
      handleAccountLockout,
      copyUsernameToClipboard,
      goBackToSignInWithUsername,
      executeRecoveryApi,
    }),
    [
      state,
      state.currentStep,
      canSubmit,
      state.touchedByStep,
      updateField,
      nextStep,
      previousStep,
      setCurrentStep,
      submit,
      canSubmit,
      canGoNext,
      canGoPrevious,
      isStepTouched,
      // Error handling
      setError,
      clearError,
      setValidationErrors,
      setFieldError,
      clearFieldErrors,
      recoveryFormData,
      updateRecoveryField,
      handleRecoveryInputValueChange,
      recoveryCanSubmit,
      submitRecovery,
      recoveryLoading,
      recoveryError,
      // Enhanced recovery state
      recoveredUsername,
      passwordResetEmail,
      newPassword,
      setNewPassword,
      confirmPassword,
      setConfirmPassword,
      accountLockoutTime,
      resendEmailCooldown,
      // Enhanced recovery functions
      canResetPassword,
      isAccountLocked,
      canResendEmail,
      getRemainingLockoutTime,
      getRemainingResendTime,
      submitPasswordResetEmail,
      resendPasswordResetEmail,
      submitNewPassword,
      handleAccountLockout,
      copyUsernameToClipboard,
      goBackToSignInWithUsername,
      executeRecoveryApi,
    ],
  )

  return <SignInContext.Provider value={value}>{children}</SignInContext.Provider>
}
